import { TypePolicy } from '@apollo/client';

export const User: TypePolicy = {
  fields: {
    displayName: {
      read(_, { readField }) {
        const nameDisplay = readField('nameDisplay');
        const firstName = readField('firstName');
        const lastName = readField('lastName');
        return nameDisplay || [firstName, lastName].join(' ').trim();
      },
    },
  },
};
